module.exports = __webpack_public_path__ + "static/media/48-web-or-mls-DJI_0139.4f4bad7d.jpg";